import {toast} from 'react-toastify';
import {api} from './index';

const reduxApi =
  (url, method, data, {success, error, updated}, actionTypes) =>
  dispatch => {
    const {
      responder,
      loading,
      error: errorConstant,
      report,
      dontRun,
    } = actionTypes;

    dispatch({
      payload: url,
      type: loading,
    });

    if (loading) {
      dispatch({
        payload: null,
        type: responder,
      });
    }

    return api[method.toLowerCase()](url, data)
      .then(res => {
        dispatch({
          payload: '',
          type: loading,
        });
        dispatch({
          payload: res.data,
          type: responder,
        });

        if (updated) {
          window.location.reload();
        }

        if (typeof success === 'function' && report !== false) {
          success(res.data, dispatch);
        }

        return true;
      })
      .catch(e => {
        dispatch({
          payload: '',
          type: loading,
        });
        dispatch({
          errorObj: e,
          payload: e.response && e.response.data,
          type: errorConstant,
        });
        if (report !== false) {
          if (
            e.response?.data?.error !==
            'Your company must be verified to access this resource'
          ) {
            !dontRun && toast.error(e.response?.data?.error);
          } else {
            toast.error('Please complete your registration process');
          }
        }

        if (typeof error === 'function' && report !== false) {
          error(e.response && e.response.data, dispatch);
        }

        return false;
      });
  };

export default reduxApi;
